// TimeOffList (Domain/Schedule; was ScheduleViews' TimeOffList, BL-189): time off, as timeOff.list says
// it, one row on hairlines each: who by their pen, the leave code, the days or hours in words, the note,
// and paid or not. A cancelled one stays, muted and struck through, with why. One action a row, for
// those who may: cancel it (onCancel); without it an unpaid one says Unpaid. Draws from ready-to-show
// words (schedule-schemas.ts' TimeOffListProps). Reads only --timeoff-*; PenKey reads its own.
import type { TimeOffListProps } from '../../schedule-schemas.ts';
import { PenKey } from '../PenKey/PenKey.tsx';
import type { Pen } from '../pen.ts';
import './TimeOffList.css';

export interface TimeOffListComponentProps {
  data: TimeOffListProps;
  onCancel?: (id: string) => void;
}

export function TimeOffList({ data, onCancel }: TimeOffListComponentProps) {
  if (!data.items.length)
    return (
      <p className="fl-timeoff__empty">
        Nobody is off. Time off booked here comes off the board and the open times.
      </p>
    );
  return (
    <ul className="fl-timeoff">
      {data.items.map((o) => (
        <li key={o.id} className="fl-timeoff__row" data-cancelled={o.cancelled ? '' : undefined}>
          <span className="fl-timeoff__main">
            <span className="fl-timeoff__who">
              <PenKey pen={(o.pen ?? null) as Pen | null}>
                <b className="fl-timeoff__name">{o.name}</b>
              </PenKey>
              <span className="fl-timeoff__muted">, {o.label.toLowerCase()}</span>
            </span>
            <span className="fl-timeoff__when">{o.text}</span>
            {o.note && <span className="fl-timeoff__sub">{o.note}</span>}
            {o.cancelled && <span className="fl-timeoff__sub">Cancelled: {o.cancelled.reason}</span>}
          </span>
          {o.cancelled ? (
            <span className="fl-timeoff__word">Cancelled</span>
          ) : onCancel ? (
            <button
              type="button"
              className="fl-timeoff__cancel"
              onClick={() => onCancel(o.id)}
              aria-label={`Cancel ${o.name}’s ${o.label.toLowerCase()}`}
            >
              Cancel it
            </button>
          ) : !o.paid ? (
            <span className="fl-timeoff__word">Unpaid</span>
          ) : null}
        </li>
      ))}
    </ul>
  );
}
